import { /* baseClient, */ authClient, API } from "../../utils/index";
import { uploadSingleFile } from "../files";

// Get all clubs
export const getClubs = () => {
	return authClient().get(`${API}/club`);
};

// Get club by id
export const getClubById = (id) => {
	return authClient().get(`${API}/club/${id}`);
};

// Delete club
export const deleteClub = (id) => {
	return authClient().delete(`${API}/club/${id}`);
};

// Create club
export const postClub = async (club, logo) => {
	if (logo) {
		const response = await uploadSingleFile(logo, "club");
		club.logo = response.data.fileURL;
	}
	return authClient().post(`${API}/club`, club);
};

// Update club
export const updateClub = async (id, club, logo) => {
	if (logo) {
		const response = await uploadSingleFile(logo, "club");
		club.logo = response.data.fileURL;
	}
	return authClient().put(`${API}/club/${id}`, club);
};
